
var util = require('../util'),
	bornModules = require('../helpers/born.modules').default,
	formPrepare = require('./checkout/formPrepare'),
	addressUtil = require('../helpers/address.utils');

const addressMap = {
	default: {
		'postal_code': {
			selector: 'input[id$="_postal"]',
			type: 'short_name'
		},
		'postal_code_prefix': 'postal_code',
		'locality': {
			selector: '[id$="_city"]',
			type: 'long_name'
		},
		'neighborhood': 'locality',
		'administrative_area_level_1': {
			selector: '[id$="_states_state"]',
			type: 'both',
			isSelect: true
		},
	},
	gb: {
		'sublocality_level_1': {
			selector: '[id$="_address2"]',
			type: 'long_name'
		},
		'administrative_area_level_1': {
			selector: '[id$="_states_state"]',
			type: 'long_name'
		},
		'postal_town': {
			selector: '[id$="_city"]',
			type: 'long_name'
		},
	},
	se: {
		'postal_town': {
			selector: '[id$="_city"]',
			type: 'long_name'
		},
	},
	ae: {
		'sublocality_level_1': {
			selector: '[id$="_address2"]',
			type: 'long_name'
		},
	},
	sa: {
		'sublocality_level_1': {
			selector: '[id$="_address2"]',
			type: 'long_name'
		},
	},
	kw: {
		'premise': {
			selector: '[id$="_address1"]',
			type: 'long_name'
		},
		'route': {
			selector: '[id$="_address2"]',
			type: 'long_name'
		},
		'sublocality_level_1': {
			selector: '[id$="_area"]',
			type: 'long_name'
		},
		'locality': {
			selector: '[id$="_address3"]',
			type: 'long_name'
		},
	},
	sg: {

	},
	us: {
		'sublocality_level_1': {
			selector: '[id$="_city"]',
			type: 'long_name'
		}
	},
	lb: {
		'premise': {
			selector: '[id$="_address1"]',
			type: 'long_name'
		},
		'route': {
			selector: '[id$="_address2"]',
			type: 'long_name'
		},
		'locality': {
			selector: '[id$="_district"]',
			type: 'long_name'
		},
	},
};

function clearFields(targetContainer) {
	var elements=[];
	if(addressUtil.getFormCountry()=='kw'){
		elements = targetContainer.querySelectorAll('input, select:not([name$="_city"])')
	}else{
		elements =	targetContainer.querySelectorAll('input, select');
	}
	
	[].forEach.call(elements, function(element) {
		element.value = '';
	});
}

function getAddressFields(country, target, url, callback) {
	//If no target container is passed, do nothing cause we don't know where to place the reponse.
	if(!target) {
		return false;
	}

	callback = callback || function() {};

	var targetContainer = document.querySelector(target);
		// valueList = getFieldValues(targetContainer);

	url = url || window.Urls.getAddressForm;

	$(targetContainer).load(util.appendParamToURL(url, 'country', country), function(){
		// setFieldValues(valueList);
		//Makes sure fields are cleared even after being saved on the session.
		clearFields(targetContainer);
		callback();
		initAutocomplete(country);
		bornModules.selectTags.init();
		addressUtil.initGovernateEvents();
		addressUtil.updateGovernateArea();
		$('.positivenumber').on('input',function(e) {
            this.value = this.value.replace(/\D/g,'');
        });
	});
}

//Applies values to field
function updateField(field, value, isSelect) {
	if(field) {

		if(isSelect) {
			field.value = field.nodeName === 'SELECT' ? value.short_name : value.long_name
		}

		else {
			field.value = value;
		}

		$(field).trigger('change');
		$(field).valid();
		if ($(field).is('select') && !$(field).hasClass('select2-option')) {
			$(field).selectric('init');
		}
	}
}

//Gets the address data values from the country and property type
function getAddressFormat(property, country) {
	let addressData = addressMap[country] && addressMap[country][property] ? addressMap[country][property] : addressMap['default'][property];

	//Call this function again to get the actual value in case a field is used to reference another.
	//Example 'postal_code_prefix': 'postal_code'
	//Means: 'postal_code_prefix' should use the properties from 'postal_code'.
	if(typeof addressData === 'string') {
		addressData = addressData === 'off' ? false : getAddressFormat(addressData);
	}

	return addressData;
}

//Loops through 'place' component and calls 'setFieldData' to map data into fields.
function populateAddress(autocompleteField, country, targetContainer) {
	var place = this.getPlace(),
		premiseName,
		routeName,
		streetNumber,
		useRouteAsName = false;

	// empty address2 and address3
	
	if(document.querySelector('[id$="_address2"]') != null) {
		document.querySelector('[id$="_address2"]').value = '';
	}
	if(document.querySelector('[id$="_address3"]') != null) {
		document.querySelector('[id$="_address3"]').value = '';
	}
	

	place.address_components.forEach(function(component) {
		let componentType = component.types[0],
			addressData = getAddressFormat(componentType, country);

		if(addressData) {
			let addressValue = addressData.type === 'both' ? component : component[addressData.type];

			updateField(document.querySelector(addressData.selector), addressValue, addressData.isSelect);
		}
		
		if(componentType === 'premise') {
			premiseName = component.long_name;
		}

		if(componentType === 'street_number') {
			streetNumber = component.long_name;
		}

		//Set these two independent values to determine if the Address Line 1 should use the 'route' data,
		//instead of the place.name data for better accuracy.
		if(componentType === 'route') {
			routeName = component.long_name;
		}

		if(componentType === 'postal_code' || componentType === 'postal_code_prefix') {
			useRouteAsName = component.short_name === place.name ? true : false;
		}

		//console.log(componentType, component.short_name, component.long_name);
	});

	//Resets the autocomplete field to avoid having a bunch of useless info there.
	//autocompleteField.value = useRouteAsName && routeName ? routeName : place.name;
	//autocompleteField.value = streetNumber && routeName ? streetNumber + ' ' + routeName : (useRouteAsName && routeName ? routeName : place.name);

	var location = (premiseName && streetNumber && routeName) ? premiseName + ' ' + streetNumber + ' ' + routeName
					: (premiseName && streetNumber) ? premiseName + ' ' + streetNumber
					: (streetNumber && routeName) ? streetNumber + ' ' + routeName
					: (premiseName) ? premiseName
					: (streetNumber) ? streetNumber
					: (routeName) ? routeName
					: place.name

	// trim returned text to 35 char max according to client requirement
	autocompleteField.value = location.substring(0, 35);

	//console.log(place);

	// this will fix the field validation issue when typing address in Arabic.
	$(autocompleteField).trigger('blur');
	
	
	if(addressUtil.getFormCountry()=='kw'){
		if(!addressUtil.isDependentAddress()) {
			document.querySelector('[id$="_city"]').value = Resources.KUWAIT_CITY;
			$('[id$="_city"]').trigger('blur');
		}
	}
	formPrepare.validateForm();
}

function initAutocomplete(country, target) {
	var autocompleteField = document.querySelector('input[id$="_address1"]');
	if(!autocompleteField) {
	    return;
	}
	var autocomplete = new google.maps.places.Autocomplete(autocompleteField, {types: ['geocode']}),
		targetContainer = document.querySelector(target);

	autocomplete.setComponentRestrictions({'country': country});
	autocomplete.addListener('place_changed', populateAddress.bind(autocomplete, autocompleteField, country, targetContainer));

	//prevents the autocomplete field from submitting from accidentally submitting the form.
	window.addEventListener('keydown', function(e) {
		if(e.target === autocompleteField && e.keyCode === 13) {
			e.preventDefault();
		}
	});
	formPrepare.validateForm();
}

exports.init = function(target, url) {
	var countrySelector = document.querySelector('[id$="_country"]');

	if(countrySelector) {
		//Uses jQuery in order to easily trigger the 'change' event for Selectric.
		$(countrySelector).on('change', function() {
		    var country = this.value;
		    if(country) {
                $(target).closest('form')
                    .find('.phone')
                    .intlTelInput('setCountry',country)
                    .val('');
            }
			getAddressFields(this.value, target, url);
		});

		initAutocomplete(countrySelector.value, target);
	}
	addressUtil.init();
}

exports.getAddressFields = getAddressFields;


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/dynamic-address.js